import React from 'react'

const BottomAdvertise = () => {
  return (
    <div>
        <h1 style={{marginTop:"50px"}}>Brand Store</h1>
    <div  className='FruitsNvegiT'>
      <div className='ChildDiv'>
        <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/1bfc68c3-152f-4ed4-bce4-40644929dff2/hp_amul-brandStorefront_m_480_251022_01.jpg" alt="Not-Found" />
      </div>
      <div className='ChildDiv'>
      <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/1bfc68c3-152f-4ed4-bce4-40644929dff2/hp_dettol-brandStorefront_m_480_251022_02.jpg" alt="Not-Found" />
      </div>
      <div className='ChildDiv'>
      <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/1bfc68c3-152f-4ed4-bce4-40644929dff2/hp_harpic-brandStorefront_m_480_091122_03.jpg" alt="Not-Found" />
      </div>
      <div className='ChildDiv'>
      <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/1bfc68c3-152f-4ed4-bce4-40644929dff2/hp_lindberg-brandStorefront_m_480_251022_04.jpg" alt="Not-Found" />
      </div>
      <div className='ChildDiv'>
      <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/1bfc68c3-152f-4ed4-bce4-40644929dff2/hp_Tasties-brandStorefront_m_480_251022_05.jpg" alt="Not-Found" />
      </div>
      <div className='ChildDiv'>
      <img src="https://www.bigbasket.com/media/customPage/77880b23-0233-4fad-b54a-a93c998e0d20/7f6ddfd5-93af-4bbd-a250-ce828daa63d6/1bfc68c3-152f-4ed4-bce4-40644929dff2/hp_durex-brandStorefront_m_480_251022_06.jpg" alt="Not-Found" />
      </div>
    </div>
    </div>
  )
}

export default BottomAdvertise